import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { isNullOrUndefined } from 'util';
import { ContractListenerURLResponse } from '../../../models/clienturl.model';
import { ContractRemoteService } from '../../../services/contractRemote.service';
import { UtilityService } from '../../../services/shared/utility.service';

@Component({
    selector: 'app-contract-listener',
    templateUrl: './contract-listener.component.html',
    styleUrls: ['./contract-listener.component.css']
})
/** contract-listener component*/
export class ContractListenerComponent implements OnInit {
    contractListenerURLResponse: ContractListenerURLResponse;
    initialLoading: boolean = true;
    /** contract-listener ctor */
    constructor(private _route: ActivatedRoute,
        private _router: Router,
        private _contactRemoteService: ContractRemoteService,
        private _utilityService: UtilityService) {
    }

    ngOnInit(): void {
        this._route.paramMap.subscribe(async params => {
            if (params.has('contactId')) {
                this.getClientRemoteURL(+params.get('contactId'));
            }
        });
    }
    private async getClientRemoteURL(contactId: number) {
        await this._contactRemoteService.getclientRemoteURLAsync("ContractListener", contactId)
            .then(async (result: ContractListenerURLResponse) => {
                if (result) {
                    if (result.statusCode == 0) {
                        this.contractListenerURLResponse = UtilityService.clone(result);
                        if (!isNullOrUndefined(this.contractListenerURLResponse) && this.contractListenerURLResponse.contractListenerURL.contactId > 0) {
                            this._router.navigateByUrl(this.contractListenerURLResponse.contractListenerURL.clientRemoteURL);
                        }
                        else
                            this.initialLoading = false;
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    navigateToClientRemote() {
        this._route.paramMap.subscribe(async params => {
            if (params.has('contactId')) {
                this.getClientRemoteURL(+params.get('contactId'));
            }
        });
    }
}
